module.exports = __webpack_public_path__ + "img/feature-message.61385fad.svg";